// extracted by mini-css-extract-plugin
export default {"root":"OWQ5ADv0l2phaTJY2HqN","starred":"YKAtoNTN44bkmZW9d8ld","unstarred":"L8Iu93NF4cv7_j6Wuxz0"};